import { usePaginatedCruises } from '@/features/world-map/hooks/use-paginated-cruises';
import { Fragment, useEffect, useRef } from 'react';
import { Cruise } from '../cruise/cruise';
import { PlusIcon } from '../plus-icon';
import classes from './cruise-list.module.css';

/**
 * @param {React.HTMLProps<HTMLDivElement>} props
 * @returns {React.JSX.Element}
 */
export function CruiseList(props) {
  const { data, hasNextPage, isFetching, fetchNextPage } = usePaginatedCruises();
  /** @type {React.RefObject<HTMLDivElement>} */
  // @ts-ignore
  const contentRef = useRef(null);
  const previousData = useRef(/** @type {typeof data} */ (undefined));

  useEffect(() => {
    const prevRecords = previousData.current?.pages.flatMap((page) => page.cruises) ?? [];
    const records = data?.pages.flatMap((page) => page.cruises) ?? [];
    previousData.current = data;

    // Reset the scroll position when a data change isn't simply loading more records
    const resetScroll =
      prevRecords.length > records.length ||
      !prevRecords.every((record, i) => records[i].year === record.year && records[i].name === record.name);

    if (resetScroll) {
      contentRef.current.scrollTo({ top: 0 });
    }
  }, [data]);

  return (
    <div {...props}>
      <div style={{ position: 'relative', height: '100%' }}>
        <div ref={contentRef} className={classes.content}>
          {data?.pages.map((page) => (
            <Fragment key={page.pagination.page}>
              {page.cruises.map((cruise) => (
                <Cruise key={`${cruise.name}${cruise.year}`} cruise={cruise} />
              ))}
            </Fragment>
          ))}
          {hasNextPage && (
            <button
              type="button"
              className={`btn ${classes.btnMore}`}
              onClick={() => fetchNextPage()}
              disabled={isFetching}
            >
              Load More <PlusIcon />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
